import { appGetState } from 'legacy/lut/store'

import { IFilter } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchPartnersToAdd = async (filter: IDataProviderFilter) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGPPartnersToAdd/call`)
  const filters = filter.filters as IFilter[]

  const geoMarket = filters.find((f) => f.field === 'GeoMarket')?.value
  const country = filters.find((f) => f.field === 'Country')?.value
  const partnerId = filters.find((f) => f.field === 'PartnerID')?.value
  const partnerName = filters.find((f) => f.field === 'CommunicationName')?.value
  const globalPartnerId = filters.find((f) => f.field === 'GlobalPartnerId')?.value

  if (globalPartnerId && (geoMarket || country || partnerId || partnerName)) {
    const payload = {
      'p.GlobalPartnerID': globalPartnerId,
      'p.Filters': JSON.stringify({
        GeoMarket: geoMarket,
        PartnerName: partnerName,
        PartnerId: partnerId,
        Country: country,
      }),
    }
    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    if (response && response.Data) {
      return { Data: response.Data }
    }
  }
  return { Data: [] }
}
